import { OperationTypeEnum, QaQcTestResultEnum, RejectionReasonsEnum, ShiftsEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class RejectionDataDto{
    @ApiProperty()
    plantId:number;
    @ApiProperty()
    lotNumber:string;
    @ApiProperty()
    subLotNumber:string;
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty()
    saleOrderItemId:number;
    @ApiProperty({
        enum: ShiftsEnum,
        default: ShiftsEnum.General
    })
    shift:ShiftsEnum;
    @ApiProperty({
        enum: OperationTypeEnum,
        default: OperationTypeEnum.GRN
    })
    operation:OperationTypeEnum;
    @ApiProperty()
    workstation:number;
    @ApiProperty()
    qaQcTestId:number;
    @ApiProperty()
    noOfSamples:number;
    @ApiProperty()
    count:number;
    @ApiProperty()
    quantityTested:number;
    @ApiProperty()
    rejectedQuantity:number;
    @ApiProperty({
        enum:RejectionReasonsEnum,
        default: RejectionReasonsEnum.BLACK_DOTES
    })
    rejectionReason:RejectionReasonsEnum;
    @ApiProperty({
        enum:QaQcTestResultEnum,
        default: QaQcTestResultEnum.TEST_RESULT
    })
    testResult:QaQcTestResultEnum;
    @ApiProperty()
    remarks:string;

    /**
     * @param plantId
     * @param lotNumber 
     * @param saleOrderId 
     * @param saleOrderItemId 
     * @param shift 
     * @param operation 
     * @param workstation 
     * @param qaQcTestId 
     * @param noOfSamples 
     * @param quantityTested 
     * @param rejectedQuantity 
     * @param rejectionReason 
     * @param testResult 
     * @param remarks 
     */
    constructor(plantId:number,lotNumber:string, saleOrderId:number, saleOrderItemId:number, shift:ShiftsEnum, operation:OperationTypeEnum, workstation:number, qaQcTestId:number, noOfSamples:number, count:number, quantityTested:number, rejectedQuantity:number, rejectionReason:RejectionReasonsEnum, testResult:QaQcTestResultEnum, remarks:string){
        this.plantId = plantId;
        this.lotNumber = lotNumber;
        this.saleOrderId = saleOrderId;
        this.saleOrderItemId = saleOrderItemId;
        this.shift = shift;
        this.operation = operation;
        this.workstation = workstation;
        this.qaQcTestId = qaQcTestId;
        this.noOfSamples = noOfSamples;
        this.count = count;
        this.quantityTested = quantityTested;
        this.rejectedQuantity = rejectedQuantity;
        this.rejectionReason = rejectionReason;
        this.testResult = testResult;
        this.remarks = remarks;
    }

}